import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// Reuses the existing thin wrappers over GET Purchase/GetVerificationVendor,
// GET Purchase/GetVerificationVendorbyCode and PUT Purchase/ApproveVendor.
import * as api from '../../api/businessinfoAPI/vendorAPI';

const err = (e, fallback) => e?.Message || e?.message || fallback;

export const fetchVerifyVendorQueue = createAsyncThunk(
    'verifyVendor/fetchQueue',
    async (roleId, { rejectWithValue }) => {
        try { return await api.getVerificationVendor(roleId); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch vendor verification queue')); }
    }
);

export const fetchVerifyVendorDetail = createAsyncThunk(
    'verifyVendor/fetchDetail',
    async ({ vendorCode, roleId }, { rejectWithValue }) => {
        try { return await api.getVerificationVendorByCode(vendorCode, roleId); }
        catch (e) { return rejectWithValue(err(e, 'Failed to fetch vendor details')); }
    }
);

export const approveVerifyVendor = createAsyncThunk(
    'verifyVendor/approve',
    async (payload, { rejectWithValue }) => {
        try { return await api.approveVendor(payload); }
        catch (e) { return rejectWithValue(err(e, 'Failed to submit vendor verification')); }
    }
);

const initialState = {
    queue: [], queueLoading: false, queueError: null,
    detail: null, detailLoading: false, detailError: null,
    verifyLoading: false, verifyError: null,
};

const verifyVendorSlice = createSlice({
    name: 'verifyVendor',
    initialState,
    reducers: {
        clearVerifyVendorDetail: (s) => { s.detail = null; s.detailError = null; s.detailLoading = false; },
        resetVerifyVendor: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchVerifyVendorQueue.pending, (s) => { s.queueLoading = true; s.queueError = null; })
            .addCase(fetchVerifyVendorQueue.fulfilled, (s, a) => { s.queueLoading = false; s.queue = a.payload?.Data || []; })
            .addCase(fetchVerifyVendorQueue.rejected, (s, a) => { s.queueLoading = false; s.queueError = a.payload; s.queue = []; });

        builder
            .addCase(fetchVerifyVendorDetail.pending, (s) => { s.detailLoading = true; s.detailError = null; s.detail = null; })
            .addCase(fetchVerifyVendorDetail.fulfilled, (s, a) => { s.detailLoading = false; s.detail = a.payload?.Data || null; })
            .addCase(fetchVerifyVendorDetail.rejected, (s, a) => { s.detailLoading = false; s.detailError = a.payload; s.detail = null; });

        builder
            .addCase(approveVerifyVendor.pending, (s) => { s.verifyLoading = true; s.verifyError = null; })
            .addCase(approveVerifyVendor.fulfilled, (s) => { s.verifyLoading = false; })
            .addCase(approveVerifyVendor.rejected, (s, a) => { s.verifyLoading = false; s.verifyError = a.payload; });
    },
});

export const { clearVerifyVendorDetail, resetVerifyVendor } = verifyVendorSlice.actions;

export const selectVVQueue = (s) => s.verifyVendor.queue;
export const selectVVQueueLoading = (s) => s.verifyVendor.queueLoading;
export const selectVVQueueError = (s) => s.verifyVendor.queueError;
export const selectVVDetail = (s) => s.verifyVendor.detail;
export const selectVVDetailLoading = (s) => s.verifyVendor.detailLoading;
export const selectVVDetailError = (s) => s.verifyVendor.detailError;
export const selectVVVerifyLoading = (s) => s.verifyVendor.verifyLoading;

export default verifyVendorSlice.reducer;
